import { cn } from "../../../utils";

type TKpiLoadersProps = {
  numberOfLoaders: number;
  className?: string;
};
export default function KpiLoaders({
  numberOfLoaders,
  className,
}: TKpiLoadersProps) {
  return (
    <>
      {Array.from({ length: numberOfLoaders }, (_, index) => {
        return (
          <div
            key={index}
            className={cn(
              "min-h-6 animate-pulse rounded-lg bg-gray/30 mb-1 d-block w-full",
              className,
            )}
            data-testid="kpi-loaders"
            aria-hidden="true"
          />
        );
      })}
    </>
  );
}
